



























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "dropzone/dist/dropzone.css";
import Dropzone from "dropzone";
import { AwsService as awsApi } from "@/common/api/services/AwsService";
import { AlbumManagementService as albumApi } from "@/common/api/services/AlbumManagementService";
import { formatImageUrl } from "@/common/utils";
import chunk from "lodash/chunk";
// import Loading from "vue-loading-overlay";

Dropzone.autoDiscover = false;

@Component({
  name: "uploadFile",
  components: {
    // Loading,
  },
})
export default class uploadFile extends Vue {
  @Prop({
    default: () => {
      return {
        uploadMultiple: false,
      };
    },
  })
  options;

  @Prop({ default: false })
  preventDuplicateName;

  @Prop({
    default: () => [],
  })
  files;

  selfFiles = [];
  errors = [];

  dropzone;

  queueUploaded = [];

  @Prop({
    default: () => 1,
  })
  maxFiles: number;

  fileErrors = [];
  @Watch("files")
  watchFileInput() {
    this.selfFiles = [...this.files].map((item) => {
      item.fullUrl = this.formatUrl(item.name);
      return item;
    });
  }
  mounted() {
    this.selfFiles = [...this.files].map((item) => {
      item.fullUrl = this.formatUrl(item.name);
      return item;
    });
    let localOptions = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "PUT",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        let _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 10,
      autoProcessQueue: true,
      maxFiles: this.maxFiles,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      // We're going to process each file manually (see `accept` below)
      // Here we request a signed upload URL when a file being accepted
      accept: async (file, done) => {
        // const extension = file.name.split(".").pop();
        // const result = await awsApi.awsUploadPresign({
        //   fileName: file.upload.uuid + "." + extension,
        //   disabledLoadinng: true,
        // } as any);
        // file.uploadURL = result.data.presign.url;
        // (file.filePath = file.upload.uuid + "." + extension), done();
        // this.dropzone.processFile(file);
      },
    };
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, {
      ...localOptions,
      ...this.options,
    });
    this.dropzone.on("addedfiles", async (files) => {
      if (this.files.length + files.length > this.maxFiles) {
        this.errors.push(
          `ファイルアップロード数 は最大 ${this.maxFiles}枚 です。`
        );
        for (const item of files) {
          this.dropzone.removeFile(item);
        }
        return;
      }

      for (const file of files) {
        if (file.size > 5 * 1024 * 1024) {
          return;
        }
      }

      if (this.preventDuplicateName) {
        const arrayFiles: any = Object.values(files) ?? [];
        if (
          this.files
            .map((item) => item.originalName ?? item.name)
            .some((item) => arrayFiles.map((file) => file.name).includes(item))
        ) {
          this.errors.push(
            `同じ画像が登録されています。アップロード済みの画像を確認するかファイル名を変更してください。`
          );
          for (const item of files) {
            this.dropzone.removeFile(item);
          }
          return;
        }
      }

      const fileList = chunk(files, 10);
      for (const items of fileList) {
        // const extension = file.name.split(".").pop();
        // const result = await awsApi.awsUploadPresign({
        //   fileName: file.upload.uuid + "." + extension,
        //   disabledLoadinng: true,
        // } as any);
        // await this.sleep(700);
        // file.uploadURL = result.data.presign.url;
        // file.filePath = file.upload.uuid + "." + extension; //, done();
        // this.dropzone.processFile(file);
        const result = await awsApi.awsUploadFilePresignMulty({
          disabledLoadinng: true,
          fileList: items.map((file) => {
            const extension = file.name.split(".").pop();
            return {
              fileName: file.upload.uuid + "." + extension,
              uuid: file.upload.uuid,
            };
          }),
        } as any);

        if (!result.errors) {
          for (const item of items) {
            const extension = item.name.split(".").pop();
            item.uploadURL = result.data.list.find(
              (url) => url.uuid === item.upload.uuid
            ).presignUrl;
            item.filePath = item.upload.uuid + "." + extension; //, done();
            this.dropzone.processFile(item);
          }
        }
      }
      // this.dropzone.processFile(files[0]);
    });
    // Set signed upload URL for each file
    this.dropzone.on("processing", (file) => {
      this.dropzone.options.url = file.uploadURL;
    });
    this.dropzone.on("success", (file) => this.uploadSuccessed(file));
    this.dropzone.on("uploadprogress", (file) => {
      console.log("uploading", true);
      this.$emit("uploading", true);
      this.addFile(file);
    });
    this.dropzone.on("error", (file, message) =>
      this.handelError(file, message)
    );
  }

  async sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  formatUrl(fileName) {
    return formatImageUrl(fileName);
  }

  open() {
    this.errors = [];
    this.dropzone.hiddenFileInput.click();
  }
  handelError(file, message = "") {
    if (
      !file.type.match("image/png") &&
      !file.type.match("image/jpg") &&
      !file.type.match("image/jpeg")
    ) {
      this.errors.push(
        `${file.name}: アップロード可能な画像形式はjpg・jpeg・pngになります`
      );
      this.dropzone.removeFile(file);
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.errors.push(
        `${file.name}: アップロード可能なサイズは 5MB以下 になります`
      );
      this.dropzone.removeFile(file);
      return;
    }

    this.errors.push(`${file.name}: ${message} (Removed)`);
    this.dropzone.removeFile(file);
  }

  async addFile(file) {
    // file.loading && file.loading.hide();
    let findFile = this.selfFiles.find(
      (item) => item.upload && item.upload.uuid === file.upload.uuid
    );
    if (findFile) {
      findFile = file;
    } else {
      if (file.status !== "error") {
        this.selfFiles.push(file);
      }
    }

    this.reRender();
    (this.$refs.imgBlock as HTMLElement).scrollTop = (
      this.$refs.imgBlock as HTMLElement
    ).scrollHeight;
  }

  public uploadSuccessed(file) {
    // call api add file
    this.reRender();
    this.queueUploaded.push(file);

    const totalSuccess = this.dropzone.files.filter(
      (file) => file.status === "success"
    ).length;

    if (totalSuccess === this.dropzone.files.length) {
      // this.$emit("uploading", false);
      this.triggerCreateData();
    }
  }

  public async triggerCreateData() {
    const fileUploadeds = this.dropzone.files.filter(
      (file) => file.status === "success" && !file.createdData
    );
    const fileList = chunk(fileUploadeds, 10);

    for (const items of fileList) {
      const result = await albumApi.groupAdminAlbumAddFileUpload({
        disabledLoadinng: true,
        list: items.map((file) => {
          const extension = file.name.split(".").pop();
          return {
            name: file.filePath,
            originalName: file.name,
            sipPath: "",
            container: "File",
            extension: extension,
            mimeType: file.type,
            size: file.size,
            md5: "md5",
            disabledLoadinng: true,
            uuid: file.upload.uuid,
          };
        }),
      } as any);

      if (!result.errors) {
        for (const file of items) {
          const record = result.data.images.find(
            (item) => item.uuid === file.upload.uuid
          );
          file.id = record.id;
          file.fullUrl = this.formatUrl(record.name);
        }
      }
    }
    this.$emit("uploading", false);
    this.$emit("changed", this.selfFiles);
  }

  public reRender() {
    this.selfFiles.unshift({ w: 1 });
    this.selfFiles.shift();
  }

  public removeFile(file, index) {
    if (file.upload) {
      // instance of file
      this.dropzone.removeFile(file);
    }
    this.selfFiles.splice(index, 1);
    this.$emit("changed", this.selfFiles);
  }
}
